
import {FeatureZone} from "../utils/FeatureZone.js";

export class FeatureZoneLoader {

	// Fetch and parse features.geojson, reproject from WGS84 to point cloud CRS.
	// Returns [] silently on 404 or any error.
	static async load(baseUrl, projection) {
		let url = baseUrl + "features.geojson";

		let response;
		try {
			response = await fetch(url);
		} catch (e) {
			return [];
		}

		if (!response.ok) {
			return [];
		}

		let json;
		try {
			json = await response.json();
		} catch (e) {
			return [];
		}

		if (!json || json.type !== "FeatureCollection" || !Array.isArray(json.features)) {
			return [];
		}

		// Set up proj4 reprojection
		proj4.defs("WGS84", "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");
		proj4.defs("pointcloud", projection);
		let transform = proj4("WGS84", "pointcloud");

		let zones = [];

		for (let feature of json.features) {
			if (!feature.geometry || feature.geometry.type !== "Polygon") {
				continue;
			}

			let coordinates = feature.geometry.coordinates;
			if (!coordinates || coordinates.length === 0) {
				continue;
			}

			// Use exterior ring only
			let ring = coordinates[0];
			let properties = feature.properties || {};

			let minHeight = properties.min_height;
			let maxHeight = properties.max_height;
			if (minHeight === undefined || maxHeight === undefined) {
				continue;
			}

			// Reproject each [lon, lat] to scene coords [x, y]
			let reprojected = [];
			for (let coord of ring) {
				let [lon, lat] = coord;
				let [x, y] = transform.forward([lon, lat]);
				reprojected.push([x, y]);
			}

			let zone = new FeatureZone(reprojected, minHeight, maxHeight, properties);
			zones.push(zone);
		}

		return zones;
	}
}
